import axios from "axios";
import Links from "../constants/Links";
import { DocumentReviewStatus } from "../constants/applicantDocumentReview";

const ApplicantDocumentReviews = {
  listForApplicant: async (applicantId) => {
    return axios.get(Links.applicantDocumentReviews.applicant + applicantId);
  },

  download: async (type, documentId) => {
    return axios.get(
      `${Links.applicantDocumentReviews.base}/${type}/${documentId}/download`,
      { responseType: "blob" }
    );
  },

  review: async (type, documentId, status, reason = null) => {
    if (![DocumentReviewStatus.APPROVED, DocumentReviewStatus.REJECTED].includes(status)) {
      throw new Error("A final document review status is required");
    }

    const reviewReason = status === DocumentReviewStatus.REJECTED
      ? String(reason || "").trim()
      : null;
    if (status === DocumentReviewStatus.REJECTED && !reviewReason) {
      throw new Error("A rejection reason is required");
    }

    return axios.patch(
      `${Links.applicantDocumentReviews.base}/${type}/${documentId}`,
      { status, reason: reviewReason }
    );
  },
};

export default ApplicantDocumentReviews;
